import React from 'react'
import { Route, Routes } from 'react-router'

import AppBarContainer from '../containers/appBarContainer';
import ViewerContainer from '../containers/viewerContainer';

const RouteError = () => <h2>RouteError</h2>;

const routes = (
    <div>
        <header>
            <AppBarContainer />
        </header>
        <Routes>
            <Route index path={process.env.REACT_APP_WEB_ROOT_PATH + "/"} element={<ViewerContainer />} />
            <Route path={process.env.REACT_APP_WEB_ROOT_PATH + "/index.html"} element={<ViewerContainer />} />
            <Route element={<RouteError />} />
        </Routes>
    </div>
)

export default routes